import { Overlay } from "../../../styles/popup";
import styled from "styled-components";

const Popup = styled.div`
  width: min(420px, calc(100vw - 48px));
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 18px;
    font-weight: 700;
  }

  > img {
    width: 17px;
    height: 17px;
    cursor: pointer;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: #e8e8e8;
`;

const Body = styled.div`
  padding: 24px;
  color: #666;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6;
  word-break: keep-all;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px 20px;

  > button {
    min-width: 72px;
    height: 40px;
    padding: 0 16px;
    border: none;
    border-radius: 8px;
    background: #7f25fb;
    color: #fff;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }
`;

interface DeleteBlockedPopupProps {
  targetLabel: "미션" | "빙고";
  onClose: () => void;
}

const DeleteBlockedPopup = ({
  targetLabel,
  onClose,
}: DeleteBlockedPopupProps) => {
  return (
    <Overlay $zIndex={1100}>
      <Popup>
        <Header>
          <div className="title">삭제 불가</div>
          <img
            src="/image-web/tournament/close.svg"
            alt="close"
            onClick={onClose}
          />
        </Header>
        <Divider />
        <Body>
          진행 중인 유저가 있어 {targetLabel === "빙고" ? "빙고를" : "미션을"}{" "}
          삭제할 수 없습니다. 수정 버튼을 눌러 진행 초기화를 먼저 진행해 주세요.
        </Body>
        <Divider />
        <Footer>
          <button type="button" onClick={onClose}>
            확인
          </button>
        </Footer>
      </Popup>
    </Overlay>
  );
};

export default DeleteBlockedPopup;
